import cn from "classnames";
import { useTranslation } from "react-i18next";
import { Loader } from "ui";

import { useGetTools, useToggleTool } from "../../apis";

import styles from "./ToolsTab.module.scss";

interface Props {
  assistantId: string;
}

const ToolsTab = ({ assistantId }: Props) => {
  const { t } = useTranslation();
  const { tools, isLoading } = useGetTools(assistantId);
  const toggleTool = useToggleTool(assistantId);

  if (isLoading) {
    return (
      <div className={styles.loaderWrap}>
        <Loader />
      </div>
    );
  }

  if (tools.length === 0) {
    return <div className={styles.empty}>{t("No tools available")}</div>;
  }

  return (
    <div className={styles.wrapper}>
      {tools.map((tool) => (
        <div key={tool.toolKey} className={styles.row}>
          <div className={styles.info}>
            <span className={styles.label}>
              {t(`aiTool.${tool.toolKey}.label`, { defaultValue: tool.label })}
            </span>
            <span className={styles.description}>
              {t(`aiTool.${tool.toolKey}.description`, {
                defaultValue: tool.description
              })}
            </span>
          </div>
          <button
            type="button"
            className={cn(styles.switch, {
              [styles.switchActive]: tool.isEnabled
            })}
            disabled={toggleTool.isLoading}
            onClick={() =>
              toggleTool.mutate({
                toolKey: tool.toolKey,
                isEnabled: !tool.isEnabled
              })
            }
            aria-label={`Toggle ${tool.label}`}
          >
            <span className={styles.switchKnob} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToolsTab;
